import { BaseModel } from "model/BaseModel";
import Pessoa from "model/administracao/cadastro/Pessoa";
import Veiculo from "./Veiculo";
import ItemManutencaoVeiculo from "./ItemManutencaoVeiculo";
import dayjs from "dayjs";
import Arquivo from "model/arquivo/Arquivo";
import Usuario from "model/administracao/cadastro/Usuario";

export default class ManutencaoVeiculo implements BaseModel {

    id: number;
    codigo: string | null;
    tipo: string;
    status: string;
	empresaResponsavel: Pessoa;
    usuarioResponsavel: Usuario | null;
	horimetroAtual: number | null;
	quilometragemAtual: number | null;
	dataManutencao: Date | null;
	valorTotal: number | null;
	veiculo: Veiculo|null;
	itens: Array<ItemManutencaoVeiculo>;
    arquivos: Array<Arquivo>;

    constructor(
        id = 0,
        codigo = null,
        tipo = '',
        status = 'GERADA',
        empresaResponsavel = new Pessoa(),
        usuarioResponsavel = null,
        horimetroAtual = 0,
        quilometragemAtual = 0,
        dataManutencao = dayjs().startOf("day").toDate(),
        valorTotal = 0,
        veiculo = null,
        itens = new Array<ItemManutencaoVeiculo>(),
        arquivos = []
    ) {
        this.id = id;
        this.codigo = codigo;
        this.tipo = tipo;
        this.status = status;
        this.empresaResponsavel = empresaResponsavel;
        this.usuarioResponsavel = usuarioResponsavel;
        this.horimetroAtual = horimetroAtual;
        this.quilometragemAtual = quilometragemAtual;
        this.dataManutencao = dataManutencao;
        this.valorTotal = valorTotal;
        this.veiculo = veiculo;
        this.itens = itens;
        this.arquivos = arquivos;
    }

}